import instance, { instanceFile } from "../../ApiConfig";
import { URLS } from "../../ApiConfig/Urls";

const fetchVehicle = async () => {
  try {
    console.log("Hello", URLS.GetAdmin + URLS.GetVehicle);
    const response = await instance.get(URLS.GetAdmin + URLS.GetVehicle);

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle");
  } catch (error) {
    throw error;
  }
};

const fetchVehicleByID = async (VehicleID) => {
  try {
    const response = await instance.get(
      URLS.GetAdmin + URLS.GetVehicleListByID + VehicleID,
    );

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle");
  } catch (error) {
    throw error;
  }
};

const fetchVehicleBYPlateNo = async (PlateNo) => {
  try {
    const response = await instance.get(
      URLS.GetVehicleListPlateNo + PlateNo + "/",
    );

    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle");
  } catch (error) {
    throw error;
  }
};

const fetchVehicleBYOwner = async (Owner) => {
  try {
    const response = await instance.get(URLS.GetVehicleListOwner + Owner + "/");
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Vehicle");
  } catch (error) {
    throw error;
  }
};

const createVehicle = async (vehicleData) => {
  try {
    // console.log("request is here ", vehicleData);
    const response = await instanceFile.post(
      URLS.GetAdmin + URLS.GetVehicleCreate,
      vehicleData,
    );

    if (response.status === 201) {
      return response.data;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

const updateVehicle = async (updateVehicleData, VehicleID) => {
  try {
    const response = await instanceFile.put(
      URLS.GetVehicle + VehicleID + "/",
      updateVehicleData,
    ); // Adjust the URL as needed
    if (response.status === 200) {
      console.log("Vehicle Updated successfully");
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("Error sending verification code:", error);
    throw error;
  }
};

const deleteVehicle = async (VehicleID) => {
  try {
    const response = await instance.delete(URLS.GetVehicle + VehicleID + "/");
    if (response.status === 204) {
      return response;
    }
    return null;
  } catch (error) {
    return null;
  }
};

const restoreVehicle = async (vehicleId) => {
  try {
    const response = await instance.post(URLS.GetVehicleRestore, vehicleId);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

const transferVehicle = async (vehicleId, owners) => {
  try {
    const response = await instanceFile.post(
      URLS.GetVehicle + vehicleId + "/transfer/",
      owners,
    );
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

const updateInsurance = async (insurance_status, vehicle_id) => {
  try {
    const response = await instance.put(
      URLS.GetAdmin +
        URLS.UpdateInsuranceStatus +
        vehicle_id +
        "/insurance-status",
      {
        insurance_status,
      },
    );

    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

const fetchDriverByVehicle = async (vehicleId) => {
  try {
    console.log(URLS.GetAdmin + URLS.GetDriverByVehicle + vehicleId);
    const response = await instance.get(
      URLS.GetAdmin + URLS.GetDriverByVehicle + vehicleId,
    );

    // console.log("resopons: ", response);
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Driver");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default {
  fetchVehicle,
  fetchVehicleBYPlateNo,
  fetchVehicleByID,
  fetchVehicleBYOwner,
  createVehicle,
  updateVehicle,
  deleteVehicle,
  restoreVehicle,
  transferVehicle,
  updateInsurance,
  fetchDriverByVehicle,
};
